import DomainsList from "./pages";
import MyDomainsListButtonComponent from "./components/MyDomainsListButton";
import {DomainData as DomainDataType} from "./models";
export default DomainsList;
export type DomainData = DomainDataType;
export {useDomainsData, useLoadDomainNamesListBL} from "./hooks";
export const MyDomainsListButton = MyDomainsListButtonComponent;